<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      :headers="tableHeaders"
      :items="guests"
      sort-by="calories"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Empresas</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-btn
            v-if="canSyncCompany"
            large
            small
            outlined
            icon
            :loading="loadingUpdateCompany"
            :disabled="loadingUpdateCompany"
            @click="sendUpdateCompany"
          >
            <v-icon>{{ icons.mdiUpdate }}</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            :append-icon="icons.mdiMagnify"
            class="mt-6"
            dense
            rounded
            outlined
            @click:append="confirmSearch()"
            label="Pesquisar"
            v-model="search"
            placeholder="Razão social, Nome Fantasia, E-mail ou CNPJ"
            @keyup.enter="confirmSearch()"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            v-if="manualRegisterEnabled"
            color="primary"
            dark
            rounded
            class="mb-2"
            @click="showDialogNewGuest = true"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
            Novo Empresa
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style=" white-space: nowrap;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                v-bind="attrs"
                @click="editItem(item)"
                v-on="on"
              >
                {{ icons.mdiPencilOutline }}
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip
            v-if="manualRegisterEnabled"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                v-bind="attrs"
                @click="deleteItem(item)"
                v-on="on"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>
    <DialogNewGuestVue
      v-model="showDialogNewGuest"
      :in_data="editedItem"
      :title="'Editar Empresa'"
      :view_mode="true"
      @out_data="saveConfirm"
    />
    <MsgDelete
      v-if="manualRegisterEnabled"
      v-model="dialogDelete"
      @delete-yes="deleteItemConfirm()"
    />
  </div>
</template>

<script>
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiMagnify,
  mdiUpdate,
} from '@mdi/js'
import {
  mapActions,
} from 'vuex'
import MsgDelete from '@/components/MsgDelete.vue'
import NoDataTable from '@/components/NoDataTable.vue'
import DialogNewGuestVue from './_components/DialogCompany.vue'

export default {
  components: {
    MsgDelete,
    NoDataTable,
    DialogNewGuestVue,
  },
  data: () => ({
    search: '',
    loadingUpdateCompany: false,
    manualRegisterEnabled: false,
    permissions: JSON.parse(localStorage.getItem('permissions')) || [],
    showDialogNewGuest: false,
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    headers: [{
      text: 'ID',
      align: 'start',
      value: 'id',
    },
    {
      text: 'NOME',
      value: 'fantasy_name',
    },
    {
      text: 'TELEFONE',
      value: 'cell_phone',
    },
    {
      text: 'EMAIL',
      value: 'email',
    },

    {
      text: '',
      align: 'end',
      value: 'actions',
      sortable: false,
    },
    ],
    guests: [],
    editedIndex: -1,
    editedItem: {},
    options: {},
    tab: null,
    items: [{
      tab: 'One',
      content: 'Tab 1 Content',
    },
    {
      tab: 'Two',
      content: 'Tab 2 Content',
    },

    ],
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiMagnify,
      mdiUpdate,
    },
  }),

  computed: {
    tableHeaders() {
      return this.headers
    },
    canSyncCompany() {
      if (!Array.isArray(this.permissions) || this.permissions.length === 0) {
        return true
      }

      return this.permissions.some(permission => permission.dir === 'register.company' && permission.action === 'updateCompany')
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Empresa' : 'Editar Empresa'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    // carrega o select tariffs
    this.loadTariffs()

    this.initialize()
  },

  methods: {
    ...mapActions('select', ['loadTariffs']),
    ...mapActions('company', ['getAll', 'store', 'update', 'delete', 'updateCompany']),
    initialize() {
      this.loadingTable = true

      const {
        page,
        itemsPerPage,
      } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
      }

      this.getAll(payload)
        .then(response => {
          this.guests = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    sendUpdateCompany() {
      this.loadingUpdateCompany = true

      this.updateCompany()
        .then(response => {
          this.guests = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
          this.$toast.success('Empresas sincronizadas com sucesso')
        })
        .catch(error => {
          let message = 'Erro ao sincronizar empresas'

          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message
          }

          this.$toast.error(message)
        })
        .finally(() => {
          this.loadingUpdateCompany = false
        })
    },
    editItem(item) {
      this.editedIndex = this.guests.indexOf(item)
      this.editedItem = {
        ...item,
      }
      this.showDialogNewGuest = true
    },

    saveConfirm(guest) {
      if (this.editedIndex == -1) {
        this.guests.push(guest) // adiciona no array
      } else {
        Object.assign(this.guests[this.editedIndex], guest) // atualiza o guest no array
      }
    },

    deleteItem(item) {
      this.dialogDelete = true
      this.editedItem = item
    },

    deleteItemConfirm() {
      const index = this.guests.indexOf(this.editedItem)
      this.delete(this.editedItem)
        .then(() => {
          this.guests.splice(index, 1)
          this.closeDelete()
          this.$toast.success('Excluído com sucesso !')
        })
        .catch()
        .finally()
    },
    confirmSearch() {
      this.initialize()
    },

    closeDelete() {
      this.dialogDelete = false
      this.editedIndex = -1
    },
  },
}
</script>

<style scoped>
.card-tab {
    min-height: 420px;
    min-width: 736px;
}

.tool_table_fam {
    height: 50px;
}
</style>
